// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ae_b","requiredAsterisk":"Info_requiredAsterisk__UUwan"};